export const footer = {
    appDescription: "With DMARCFlow, companies stay in control of their email security. The platform offers an easy way to manage DMARC, SPF and DKIM entries, analyze reports and identify potential risks at an early stage.",
    navigation: {
        title: "Navigation",
        entries: {
            home: "Home",
            dmarc: "DMARC",
            spf: "SPF",
            dkim: "DKIM",
            bimi: "BIMI",
            pricing: "Pricing"
        }
    },
    contact: {
        title: "Contact",
        email: "Email",
        phone: "Phone",
        address: "Adress"
    },
    company: "Ucar Solutions UG",
    imprint: "Imprint",
    privacy: "Privacy Policy"
}